import { ListItem, Stack, Typography } from '@mui/material';
import { Link, ReferenceField } from 'react-admin';

import { Avatar } from '../suppliercontacts/Avatar';
import type { ActivityContactCreated } from '../types';
import { BuyerName } from '../buyers/BuyerName';
import { RelativeDate } from '../misc/RelativeDate';
import { useActivityLogContext } from './ActivityLogContext';

type ActivityLogContactCreatedProps = {
    activity: ActivityContactCreated;
};

export function ActivityLogContactCreated({
    activity,
}: ActivityLogContactCreatedProps) {
    const context = useActivityLogContext();
    const { contact } = activity;
    return (
        <ListItem disableGutters>
            <Stack direction="row" spacing={1} alignItems="center" width="100%">
                <Avatar width={20} height={20} record={contact} />
                <Typography
                    component="p"
                    variant="body2"
                    color="text.secondary"
                    flexGrow={1}
                >
                    Contato{' '}
                    <Link to={`/suppliercontacts/${contact.id}/show`}>
                        {contact.nome_contato}
                    </Link>{' '}
                    {context !== 'company' && (
                        <>
                            em{' '}
                            <ReferenceField
                                source="id_pessoa"
                                reference="persons"
                                record={activity}
                                link="show"
                            />{' '}alterado{' '}
                            <RelativeDate date={activity.data_hora} />
                        </>
                    )}
                </Typography>
                {context === 'company' && (
                    <Typography
                        color="textSecondary"
                        variant="body2"
                        component="span"
                    >
                        <RelativeDate date={activity.data_hora} />
                    </Typography>
                )}
            </Stack>
        </ListItem>
    );
}
